import { copy } from "../copy";

export function Landing() {
  return (
    <section className="content">
      <div>
        <h2>{copy.guideTitle}</h2>
        <p>{copy.guideOne}</p>
        <p>{copy.guideTwo}</p>
        <p>{copy.guideThree}</p>
      </div>
      <div>
        <h2>{copy.qualityTitle}</h2>
        <p>{copy.qualityText}</p>
      </div>
      <div>
        <h2>{copy.faqTitle}</h2>
        {copy.faqItems.map((item) => (
          <details key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
